<template>
  <div style="text-align:left;">
    <TopNav />
    <div class="column-left">
      <SideNav />
    </div>

    <div class="column-right">
      <!-- === Authorization Check Restored === -->
      <!-- 1. Show main content IF admin_datos loaded AND user is superadmin -->
      <div v-if="admin_datos && admin_datos.user_type === 'property_manager'" class="main-container">

        <!-- Welcome Message -->
        <div style="margin-bottom: 20px; padding: 15px; background-color: #eef7ff; border-radius: 8px; border: 1px solid #cce5ff;">
           <h2 style="margin-top:0;">¡Muy buenos días {{admin_datos.nombre}}...! <img :src="admin_datos.empresa && admin_datos.empresa.atributos && admin_datos.empresa.atributos.logo_filename ? admin_datos.empresa.atributos.logo_filename : require('@/assets/logo-jobbing-nuevo.webp')"  style="height:40px; vertical-align: middle;" alt="Logo"></h2>
          El propósito de este panel es ayudarte en tu negocio 🚀.
        </div>

        <!-- Global Loading State (Only for Initial Load) -->
        <div v-if="isInitialLoading" class="articulo-principal loading-indicator">
          <p>Cargando datos iniciales del panel...</p>
        </div>

        <!-- Global Error State -->
        <div v-else-if="errorLoading && !Object.values(sectionIsLoading).some(l => l)" class="articulo-principal error-message"> <!-- Show global error only if no section is specifically loading -->
           <p>Error al cargar los datos del panel: {{ errorLoading }}</p>
           <button @click="fetchDashboardData">Intentar de nuevo</button>
        </div>

        <!-- Data Grid (Shown after initial load, handles per-section loading) -->
        <div v-else class="articulo-principal">
          <div class="dashboard-grid">

            <!-- Presupuestos Enviados -->
            <div class="dashboard-section">
              <div class="section-header">
                 <h3>Presupuestos Enviados</h3>
                 <div class="section-pagination-controls">
                   <button @click="changeSectionPage('presupuestosEnviados', -1)" :disabled="sectionPages.presupuestosEnviados <= 1 || sectionIsLoading.presupuestosEnviados || isInitialLoading">«</button>
                   <span>Pág. {{ sectionPages.presupuestosEnviados }}</span>
                   <button @click="changeSectionPage('presupuestosEnviados', 1)" :disabled="sectionIsLastPage.presupuestosEnviados || sectionIsLoading.presupuestosEnviados || isInitialLoading">»</button>
                 </div>
              </div>
              <div class="table-container">
                <!-- Per-Section Loader -->
                 <div v-if="sectionIsLoading.presupuestosEnviados" class="section-loader">Cargando...</div>
                 <!-- Table Content or No Data Message -->
                 <div v-else>
                     <table v-if="presupuestosEnviados.length">
                       <thead>
                         <tr><th></th><th>Profesional</th><th>Cliente</th><th>Dirección Cliente</th><th>Fecha</th><th>Monto</th><th>Monto Pagado</th><th>Estado</th><th>Rev. AI</th></tr>
                       </thead>
                       <tbody>
                         <tr v-for="presupuesto in presupuestosEnviados" :key="'pres-'+presupuesto.id" :title="'Detalles:\n' + imprimirItems(presupuesto) + revisionAITooltip(presupuesto)">
                           <td><span v-if="isPaymentDiscrepancy(presupuesto)" class="warning-icon" title="Pago asociado a la orden es menor al monto del presupuesto aceptado">⚠️</span></td>
                           <td>{{ presupuesto.profesional_nombre }}</td><td>{{ presupuesto.cliente_nombre }}</td><td>{{ presupuesto.cliente_direccion_corta }}</td>
                           <td>{{ formatDisplayDate(presupuesto.fecha) }}</td><td>${{ presupuesto.monto.toLocaleString('es-CL') }}</td>
                           <td>${{ (presupuesto.monto_pagado_orden || 0).toLocaleString('es-CL') }}</td>
                           <td><span :class="['badge', mapPresupuestoStatus(presupuesto.estado).className]">{{ mapPresupuestoStatus(presupuesto.estado).text }}</span></td>
                           <td><span :class="['badge', mapRevisionAIStatus(presupuesto.revision_ai).className]" :title="getRevisionAIComment(presupuesto)">{{ mapRevisionAIStatus(presupuesto.revision_ai).text }}</span></td>
                         </tr>
                       </tbody>
                     </table>
                     <div v-else class="no-data-message">
                        No hay presupuestos enviados en esta página.
                     </div>
                 </div>
              </div>
            </div>
            <!-- End Presupuestos Enviados -->

             <!-- Próximas Visitas -->
             <div class="dashboard-section">
               <div class="section-header">
                  <h3>Próximas Visitas</h3>
                  <div class="section-pagination-controls">
                    <button @click="changeSectionPage('proximasVisitas', -1)" :disabled="sectionPages.proximasVisitas <= 1 || sectionIsLoading.proximasVisitas || isInitialLoading">«</button>
                    <span>Pág. {{ sectionPages.proximasVisitas }}</span>
                    <button @click="changeSectionPage('proximasVisitas', 1)" :disabled="sectionIsLastPage.proximasVisitas || sectionIsLoading.proximasVisitas || isInitialLoading">»</button>
                  </div>
               </div>
               <div class="table-container">
                  <div v-if="sectionIsLoading.proximasVisitas" class="section-loader">Cargando...</div>
                  <div v-else>
                     <table v-if="proximasVisitas.length">
                        <thead><tr><th>Fecha y Hora</th><th>Dirección</th><th>Comuna</th><th>Profesional</th><th>Cliente</th><th>Estado</th></tr></thead>
                        <tbody>
                           <tr v-for="visita in proximasVisitas" :key="'vis-'+visita.id">
                              <td>{{ formatDisplayDate(visita.fecha, false) }} {{ visita.hora }}</td><td>{{ visita.direccion }}</td><td>{{ visita.comuna }}</td>
                              <td>{{ visita.profesional_nombre }}</td><td>{{ visita.cliente_nombre }}</td>
                              <td><span :class="['badge', mapVisitaStatus(visita.estado).className]">{{ mapVisitaStatus(visita.estado).text }}</span></td>
                           </tr>
                        </tbody>
                     </table>
                     <div v-else class="no-data-message">
                        No hay visitas programadas en esta página.
                     </div>
                  </div>
               </div>
             </div>
             <!-- End Próximas Visitas -->

             <!-- Presupuestos pendientes de enviar -->
             <div class="dashboard-section">
               <div class="section-header">
                  <h3>Presupuestos pendientes</h3>
                  <div class="section-pagination-controls">
                    <button @click="changeSectionPage('presupuestosPendientesEnviar', -1)" :disabled="sectionPages.presupuestosPendientesEnviar <= 1 || sectionIsLoading.presupuestosPendientesEnviar || isInitialLoading">«</button>
                    <span>Pág. {{ sectionPages.presupuestosPendientesEnviar }}</span>
                    <button @click="changeSectionPage('presupuestosPendientesEnviar', 1)" :disabled="sectionIsLastPage.presupuestosPendientesEnviar || sectionIsLoading.presupuestosPendientesEnviar || isInitialLoading">»</button>
                  </div>
               </div>
               <div class="table-container">
                 <div v-if="sectionIsLoading.presupuestosPendientesEnviar" class="section-loader">Cargando...</div>
                 <div v-else>
                    <table v-if="presupuestosPendientesEnviar.length">
                      <thead><tr><th></th><th>ID Orden</th><th>ID Solicitud</th><th>Profesional</th><th>Cliente</th><th>Dirección</th><th>Días Pendiente</th></tr></thead>
                      <tbody>
                        <tr v-for="presupuesto in presupuestosPendientesEnviar" :key="'pend-'+presupuesto.orden_id">
                          <td><span v-if="presupuesto.diasPendiente >= 5" class="warning-icon" title="Plazo vencido">⚠️</span></td><td>#{{ presupuesto.orden_id }}</td><td>{{ presupuesto.solicitud_id }}</td>
                          <td>{{ presupuesto.profesional_nombre }}</td><td>{{ presupuesto.cliente }}</td><td>{{ presupuesto.direccion }}</td><td>{{ presupuesto.diasPendiente }}</td>
                        </tr>
                      </tbody>
                    </table>
                    <div v-else class="no-data-message">
                       No hay presupuestos pendientes en esta página.
                    </div>
                 </div>
               </div>
             </div>
             <!-- End Presupuestos pendientes -->

             <!-- Solicitudes sin Respuesta -->
<!--              <div class="dashboard-section">
               <div class="section-header">
                 <h3>Solicitudes sin Respuesta</h3>
                 <div class="section-pagination-controls">
                   <button @click="changeSectionPage('solicitudesSinRespuesta', -1)" :disabled="sectionPages.solicitudesSinRespuesta <= 1 || sectionIsLoading.solicitudesSinRespuesta || isInitialLoading">«</button>
                   <span>Pág. {{ sectionPages.solicitudesSinRespuesta }}</span>
                   <button @click="changeSectionPage('solicitudesSinRespuesta', 1)" :disabled="sectionIsLastPage.solicitudesSinRespuesta || sectionIsLoading.solicitudesSinRespuesta || isInitialLoading">»</button>
                 </div>
               </div>
               <div class="table-container">
                 <div v-if="sectionIsLoading.solicitudesSinRespuesta" class="section-loader">Cargando...</div>
                 <div v-else>
                   <table v-if="solicitudesSinRespuesta.length">
                     <thead><tr><th>Cliente</th><th>Título</th><th>Descripción (inicio)</th><th>Fecha</th><th>Categoría</th><th>Tipo</th></tr></thead>
                     <tbody>
                       <tr v-for="solicitud in solicitudesSinRespuesta" :key="'sol-'+solicitud.id">
                         <td>{{ solicitud.cliente_nombre }}</td><td>{{ solicitud.titulo }}</td><td>{{ solicitud.descripcion_corta }}...</td><td>{{ formatDisplayDate(solicitud.fecha) }}</td>
                         <td>{{ solicitud.categoria }}</td>
                         <td><span :class="['badge', mapSolicitudType(solicitud.tipo).className]">{{ mapSolicitudType(solicitud.tipo).text }}</span>
                           <span v-if="solicitud.tipo === 'Privada' && solicitud.profesional_asignado" class="profesional-detail">({{ solicitud.profesional_asignado }})</span></td>
                       </tr>
                     </tbody>
                   </table>
                   <div v-else class="no-data-message">
                      No hay solicitudes sin respuesta en esta página.
                   </div>
                 </div>
               </div>
             </div> -->
             <!-- End Solicitudes -->

             <!-- Últimos Pagos -->
             <div class="dashboard-section">
               <div class="section-header">
                 <h3>Últimos Pagos Recibidos</h3>
                 <div class="section-pagination-controls">
                   <button @click="changeSectionPage('ultimosPagos', -1)" :disabled="sectionPages.ultimosPagos <= 1 || sectionIsLoading.ultimosPagos || isInitialLoading">«</button>
                   <span>Pág. {{ sectionPages.ultimosPagos }}</span>
                   <button @click="changeSectionPage('ultimosPagos', 1)" :disabled="sectionIsLastPage.ultimosPagos || sectionIsLoading.ultimosPagos || isInitialLoading">»</button>
                 </div>
               </div>
               <div class="table-container">
                 <div v-if="sectionIsLoading.ultimosPagos" class="section-loader">Cargando...</div>
                 <div v-else>
                    <table v-if="ultimosPagos.length">
                      <thead><tr><th>Cliente</th><th>Profesional</th><th>Dirección</th><th>Fecha</th><th>Monto</th></tr></thead>
                      <tbody>
                        <tr v-for="pago in ultimosPagos" :key="'pago-'+pago.id">
                          <td>{{ pago.cliente_nombre }}</td><td>{{ pago.profesional_nombre }}</td><td>{{ pago.direccion }}</td><td>{{ formatDisplayDate(pago.fecha) }}</td><td>${{ pago.monto.toLocaleString('es-CL') }}</td>
                        </tr>
                      </tbody>
                    </table>
                    <div v-else class="no-data-message">
                      No hay pagos registrados en esta página.
                    </div>
                 </div>
               </div>
             </div>
             <!-- End Pagos -->

             <!-- Ordenes en Curso -->
             <div class="dashboard-section">
               <div class="section-header">
                 <h3>Órdenes en Curso</h3>
                 <div class="section-pagination-controls">
                   <button @click="changeSectionPage('ordenesEnCurso', -1)" :disabled="sectionPages.ordenesEnCurso <= 1 || sectionIsLoading.ordenesEnCurso || isInitialLoading">«</button>
                   <span>Pág. {{ sectionPages.ordenesEnCurso }}</span>
                   <button @click="changeSectionPage('ordenesEnCurso', 1)" :disabled="sectionIsLastPage.ordenesEnCurso || sectionIsLoading.ordenesEnCurso || isInitialLoading">»</button>
                 </div>
               </div>
               <div class="table-container">
                 <div v-if="sectionIsLoading.ordenesEnCurso" class="section-loader">Cargando...</div>
                 <div v-else>
                    <table v-if="ordenesEnCurso.length">
                      <thead><tr><th>ID Orden</th><th>Cliente</th><th>Profesional</th><th>Servicio</th><th>Estado</th><th>Fecha Inicio</th></tr></thead>
                      <tbody>
                        <tr v-for="orden in ordenesEnCurso" :key="'ord-'+orden.id_orden">
                          <td>#{{ orden.id_orden }}</td><td>{{ orden.cliente_nombre }}</td><td>{{ orden.profesional_nombre }}</td><td>{{ orden.servicio }}</td>
                          <td><span :class="['badge', 'status-badge', getStatusClass(orden.estado)]">{{ orden.estado }}</span></td><td>{{ formatDisplayDate(orden.fecha_inicio) }}</td>
                        </tr>
                      </tbody>
                    </table>
                    <div v-else class="no-data-message">
                       No hay órdenes en curso en esta página.
                    </div>
                 </div>
               </div>
             </div>
             <!-- End Ordenes -->

             <!-- Últimas Calificaciones -->
             <div class="dashboard-section">
               <div class="section-header">
                 <h3>Últimas Calificaciones</h3>
                 <div class="section-pagination-controls">
                   <button @click="changeSectionPage('ultimasCalificaciones', -1)" :disabled="sectionPages.ultimasCalificaciones <= 1 || sectionIsLoading.ultimasCalificaciones || isInitialLoading">«</button>
                   <span>Pág. {{ sectionPages.ultimasCalificaciones }}</span>
                   <button @click="changeSectionPage('ultimasCalificaciones', 1)" :disabled="sectionIsLastPage.ultimasCalificaciones || sectionIsLoading.ultimasCalificaciones || isInitialLoading">»</button>
                 </div>
               </div>
               <div class="table-container">
                 <div v-if="sectionIsLoading.ultimasCalificaciones" class="section-loader">Cargando...</div>
                 <div v-else>
                   <table v-if="ultimasCalificaciones.length">
                     <thead><tr><th>Cliente</th><th>Profesional</th><th>Calificación</th><th>Comentario</th><th>Fecha</th></tr></thead>
                     <tbody>
                       <tr v-for="calificacion in ultimasCalificaciones" :key="'cal-'+calificacion.id">
                         <td>{{ calificacion.cliente_nombre }}</td><td>{{ calificacion.profesional_nombre }}</td><td>{{ '⭐'.repeat(calificacion.calificacion) }} ({{ calificacion.calificacion }}/5)</td>
                         <td>"{{ calificacion.comentario }}"</td><td>{{ formatDisplayDate(calificacion.fecha) }}</td>
                       </tr>
                     </tbody>
                   </table>
                   <div v-else class="no-data-message">
                      No hay calificaciones en esta página.
                   </div>
                 </div>
               </div>
             </div>
            <!-- End Calificaciones -->

            

          </div> <!-- End Dashboard Grid -->
        </div>

      </div> <!-- End v-if for admin_datos check -->

      <!-- 2. Show user loading message IF admin_datos is not yet loaded -->
      <div v-else-if="!admin_datos" class="main-container loading-indicator">
         <p>Cargando datos de usuario...</p>
      </div>

      <!-- 3. Show unauthorized message IF admin_datos loaded BUT user is not superadmin -->
      <div v-else class="main-container">
         <p>Acceso no autorizado.</p>
      </div>
       <!-- === End Authorization Check === -->

    </div> <!-- End column-right -->
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters, mapActions } from 'vuex';
import SideNav from '@/components/SideNav.vue';
import TopNav from '@/components/TopNav.vue';

const SECTION_KEYS = [
  'presupuestosEnviados',
  'proximasVisitas',
  'presupuestosPendientesEnviar',
  // 'solicitudesSinRespuesta', // This section seems commented out in the template
  'ultimosPagos',
  'ordenesEnCurso',
  'ultimasCalificaciones',
];

// Helper function to create initial state objects
const createInitialState = (defaultValue) => {
  const state = {};
  SECTION_KEYS.forEach(key => {
    state[key] = defaultValue;
  });
  return state;
};


export default {
  name: 'AdminDashboard',
  props: ['id'],
  components: { SideNav, TopNav },
  data() {
    return {
      isInitialLoading: true, // For the very first data load
      errorLoading: null, // For global API errors
      limitPerPage: 20, // Match backend limit

      // Store page number and last page status PER section
      sectionPages: createInitialState(1), // e.g., { presupuestosEnviados: 1, ... }
      sectionIsLastPage: createInitialState(false), // e.g., { presupuestosEnviados: false, ... }
      sectionIsLoading: createInitialState(false), // e.g., { presupuestosEnviados: false, ... }

      // Data arrays
      presupuestosEnviados: [],
      proximasVisitas: [],
      presupuestosPendientesEnviar: [],
      solicitudesSinRespuesta: [],
      ultimosPagos: [],
      ordenesEnCurso: [],
      ultimasCalificaciones: [],
      ESTADO_PRESUPUESTO_ACEPTADO: 2,
      REVISION_AI_PENDIENTE: 0,
      REVISION_AI_CONGRUENTE: 1,
      REVISION_AI_INCONGRUENTE: 2,
      REVISION_AI_INDETERMINADO: 3,
    }
  },
  created() {
    // Fetch initial data only if authorized (or wait for watcher)
    if (this.admin_datos && this.admin_datos.user_type === 'property_manager') {
      this.fetchDashboardData();
    }
    // this.initialize(); // Uncomment if needed from vuex actions
  },
  methods: {
    ...mapActions(['initialize']),

    async fetchDashboardData() {
      // Don't reset section loaders here, they are set by changeSectionPage
      this.errorLoading = null; // Reset global error on new fetch

      const params = new URLSearchParams();
      params.append('presupuestos_page', this.sectionPages.presupuestosEnviados);
      params.append('visitas_page', this.sectionPages.proximasVisitas);
      params.append('pendientes_page', this.sectionPages.presupuestosPendientesEnviar);
      params.append('solicitudes_page', this.sectionPages.solicitudesSinRespuesta); // Keep if backend provides data, even if template is commented out
      params.append('pagos_page', this.sectionPages.ultimosPagos);
      params.append('ordenes_page', this.sectionPages.ordenesEnCurso);
      params.append('calificaciones_page', this.sectionPages.ultimasCalificaciones);

      const apiUrl = `${window.hostname}/api/property_manager/dashboard/section_paged?${params.toString()}`;

      try {
        const response = await axios.get(apiUrl);
        if (response && response.data) {
          const data = response.data;

          // Update data arrays
          this.presupuestosEnviados = data.presupuestos_enviados || [];
          this.proximasVisitas = data.proximas_visitas || [];
          this.presupuestosPendientesEnviar = data.presupuestos_pendientes_enviar || [];
          this.solicitudesSinRespuesta = data.solicitudes_sin_respuesta || [];
          this.ultimosPagos = data.ultimos_pagos || [];
          this.ordenesEnCurso = data.ordenes_en_curso || [];
          this.ultimasCalificaciones = data.ultimas_calificaciones || [];

          // Update 'isLastPage' status for EACH section
          this.sectionIsLastPage.presupuestosEnviados = this.presupuestosEnviados.length < this.limitPerPage;
          this.sectionIsLastPage.proximasVisitas = this.proximasVisitas.length < this.limitPerPage;
          this.sectionIsLastPage.presupuestosPendientesEnviar = this.presupuestosPendientesEnviar.length < this.limitPerPage;
          this.sectionIsLastPage.solicitudesSinRespuesta = this.solicitudesSinRespuesta.length < this.limitPerPage;
          this.sectionIsLastPage.ultimosPagos = this.ultimosPagos.length < this.limitPerPage;
          this.sectionIsLastPage.ordenesEnCurso = this.ordenesEnCurso.length < this.limitPerPage;
          this.sectionIsLastPage.ultimasCalificaciones = this.ultimasCalificaciones.length < this.limitPerPage;

        } else {
          throw new Error("Respuesta inválida desde el servidor");
        }
      } catch (error) {
        console.error("Error fetching section-paginated dashboard data:", error);
        this.errorLoading = error.response?.data?.error || error.message || "Ocurrió un error desconocido.";
      } finally {
        this.isInitialLoading = false; // Mark initial load as complete
        // Reset ALL section loading flags after any fetch completes
        // Ensure only the *currently changing* flag is reset after its specific fetch
        Object.keys(this.sectionIsLoading).forEach(key => {
          if(this.sectionIsLoading[key]) { // Only reset ones that were set to true
             this.$set(this.sectionIsLoading, key, false);
          }
        });
      }
    },

    changeSectionPage(sectionKey, direction) {
       // Prevent changes during initial load or if already loading that section
       if (this.isInitialLoading || this.sectionIsLoading[sectionKey]) return;

      const currentPage = this.sectionPages[sectionKey];
      const nextPage = currentPage + direction;

      if (direction > 0 && this.sectionIsLastPage[sectionKey]) return;
      if (direction < 0 && currentPage <= 1) return;

      // Set loading state *only* for the changing section
      this.$set(this.sectionIsLoading, sectionKey, true);
      this.errorLoading = null; // Clear global error when trying a section change

      this.$set(this.sectionPages, sectionKey, nextPage);
      this.fetchDashboardData(); // Refetch all data
    },

    // --- Existing Helper Methods (Condensed for brevity - keep full logic) ---
    isPaymentDiscrepancy(p) { return (p.estado === this.ESTADO_PRESUPUESTO_ACEPTADO && (p.monto_pagado_orden || 0) < p.monto); },
    imprimirItems(p) { if (p?.desgloce?.items?.length) { return p.desgloce.items.map(i => `${i.nombre}: $${(i.precio || 0).toLocaleString('es-CL')}`).join('\n'); } else { return 'No hay items.'; } },
    mapPresupuestoStatus(s) { /* ... mapping logic ... */ switch(s){case 0:return{text:'Pendiente',className:'status-pending'};case 1:return{text:'Enviado',className:'status-sent'};case 2:return{text:'Aceptado',className:'status-accepted'};case 3:return{text:'Completado',className:'status-completed'};case 10:return{text:'Rechazado',className:'status-rejected'};default:return{text:`Desc(${s})`,className:'status-default'};} },
    mapRevisionAIStatus(s) {
      switch(s){
        case this.REVISION_AI_CONGRUENTE:
          return { text:'Congruente', className:'revision-congruente' };
        case this.REVISION_AI_INCONGRUENTE:
          return { text:'Incongruente', className:'revision-incongruente' };
        case this.REVISION_AI_INDETERMINADO:
          return { text:'Indeterminado', className:'revision-indeterminado' };
        case this.REVISION_AI_PENDIENTE:
        default:
          return { text:'Pendiente', className:'revision-pendiente' };
      }
    },
    revisionAITooltip(p) {
      if(p.revision_ai === undefined || p.revision_ai === null) return '';
      let text = `\nRevisión AI: ${this.mapRevisionAIStatus(p.revision_ai).text}`;
      const comentario = p.desgloce?.revision_ai?.resultado?.comentario;
      if(comentario) {
        text += `\nComentario: ${comentario}`;
      }
      return text;
    },
    getRevisionAIComment(p){
      return p?.desgloce?.revision_ai?.resultado?.comentario || '';
    },
    mapVisitaStatus(s) { /* ... mapping logic ... */ switch(s){case 0:return{text:'Pendiente',className:'status-pending'};case 1:return{text:'Agendada',className:'status-scheduled'};case 2:return{text:'Confirmada',className:'status-accepted'};case 3:return{text:'En proceso',className:'status-inprogress'};case 4:return{text:'Completada',className:'status-completed'};default:return{text:`Desc(${s})`,className:'status-default'};} },
    mapSolicitudType(t) { /* ... mapping logic ... */ if(t==='Privada'){return{text:'Privada',className:'type-privada'};}else{return{text:'Pública',className:'type-publica'};} },
    getStatusClass(s) { /* ... mapping logic ... */ const l=s?s.toLowerCase():'';switch(l){case 'en progreso':case 'en proceso':return 'status-inprogress';case 'agendado':return 'status-scheduled';case 'completado':case 'atendido':return 'status-completed';case 'confirmado':return 'status-accepted';case 'esperando materiales':return 'status-waiting';case 'cancelado':return 'status-cancelled';case 'pendiente':return 'status-pending';default:return 'status-default';} },
    formatDisplayDate(d, t = true) { /* ... formatting logic ... */ if(!d)return 'N/A';try{const m=d.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2}))?/);if(!m)return d;const[,y,mo,da,h='00',mi='00']=m;if(!t){return `${da}/${mo}/${y}`;}return `${da}/${mo}/${y} ${h}:${mi}`;}catch(e){console.warn("Date format error:",d,e);return d;} },
  },
  computed: {
    ...mapGetters(['comunas', 'categorias', 'regiones', 'tipos', 'admin_datos']),
  },
  mounted() {
    // Use nextTick for the redirect check in case admin_datos isn't immediately available
/*     this.$nextTick(() => {
      if (!this.admin_datos || !this.admin_datos.superadmin) {
        console.warn("User is not a superadmin or admin_datos not loaded initially (mounted), redirecting.");
        this.$router.push('/'); // Redirect to home or login page
      }
    }); */
    // Initial data fetch should only happen once on creation/mounting
    // if (this.admin_datos && this.admin_datos.user_type === 'property_manager') {
    //    this.fetchDashboardData();
    // } // This is already handled in `created`
  },
  watch: {
    admin_datos: {
        handler(newVal) {
            // If admin_datos becomes available and user is property_manager, fetch data
            if (newVal && newVal.user_type === 'property_manager' && this.isInitialLoading) {
                this.fetchDashboardData();
            }
            // If admin_datos becomes unavailable or user type changes, potentially redirect or show unauthorized
             if (!newVal || newVal.user_type !== 'property_manager') {
                // console.log("Redirecting because admin_datos changed or user type is not property_manager");
                // this.$router.push('/'); // Or handle unauthorized access appropriately
            }
        },
        immediate: true // Run the handler immediately on component creation
    }
  }
}
</script>

<style scoped>
/* --- Base & Existing Styles (Unchanged) --- */
.warning-icon { display: inline-block; margin-left: 8px; color: #ffc107; font-weight: bold; cursor: default; }
td, th { text-align: left; padding: 8px 12px; border-bottom: 1px solid #eee; vertical-align: middle; }
th { background-color: #f8f9fa; font-weight: 600; vertical-align: middle; }
/* tr:hover { background-color: #f1f1f1; } */ /* Removed hover to prevent styling on no-data row */
table { margin-left: 0; margin-right: 0; width: 100%; border-collapse: collapse; margin-top: 10px; font-size: 0.9em; }
.column-right { background-color: rgb(242, 247, 251); padding-top: 80px; padding-left: 260px; width: 100%; min-height: 100vh; box-sizing: border-box; }
.main-container { background-color: white; margin: 20px; padding: 20px 20px 10px 20px; border-radius: 8px; box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); }
.dashboard-grid { display: grid; grid-template-columns: 1fr; gap: 25px; }
@media (min-width: 1200px) { .dashboard-grid { grid-template-columns: 1fr 1fr; } }
.dashboard-section { background-color: #fff; padding: 0px 20px 15px 20px; border-radius: 6px; border: 1px solid #e9ecef; overflow: hidden; }
.dashboard-section h3 { margin-top: 0; margin-bottom: 0px; color: #333; font-size: 1.1em; }
.table-container { max-width: 100%; overflow-x: auto; margin-top: 5px; min-height: 100px; /* Give space for loader/message */ position: relative; }
.badge { display: inline-block; padding: 4px 10px; border-radius: 12px; font-size: 0.8em; font-weight: 600; line-height: 1; text-align: center; white-space: nowrap; vertical-align: baseline; color: #fff; }
/* ... other badge styles ... */
.status-inprogress{background-color:#007bff}.status-scheduled{background-color:#ffc107;color:#212529}.status-completed{background-color:#28a745}.status-waiting{background-color:#fd7e14}.status-cancelled{background-color:#6c757d}.status-pending{background-color:#6c757d}.status-default{background-color:#17a2b8}.status-sent{background-color:#17a2b8}.status-accepted{background-color:#20c997}.status-rejected{background-color:#dc3545}.type-publica{background-color:#0dcaf0}.type-privada{background-color:#6f42c1}.profesional-detail{font-size:.9em;color:#555;margin-left:5px}
.revision-pendiente{background-color:#6c757d}.revision-congruente{background-color:#28a745}.revision-incongruente{background-color:#dc3545}.revision-indeterminado{background-color:#ffc107;color:#212529}
.loading-indicator, .error-message { text-align: center; padding: 40px 20px; color: #555; }
.error-message { color: #dc3545; background-color: #f8d7da; border: 1px solid #f5c6cb; border-radius: 4px; margin-bottom: 20px; }
.error-message button { margin-top: 10px; padding: 5px 15px; cursor: pointer; border: 1px solid #dc3545; background-color: #dc3545; color: white; border-radius: 4px; }
.error-message button:hover { background-color: #c82333; border-color: #bd2130; }

/* --- Section Header and Pagination Styles (Unchanged) --- */
.section-header { display: flex; justify-content: space-between; align-items: center; padding: 15px 0 10px 0; border-bottom: 1px solid #eee; margin-bottom: 10px; }
.section-pagination-controls { display: flex; align-items: center; gap: 8px; }
.section-pagination-controls button { padding: 3px 8px; font-size: 0.9em; line-height: 1; border: 1px solid #ccc; background-color: #f8f9fa; color: #333; cursor: pointer; border-radius: 3px; transition: background-color 0.15s ease-in-out; }
.section-pagination-controls button:hover:not(:disabled) { background-color: #e9ecef; }
.section-pagination-controls button:disabled { color: #aaa; cursor: not-allowed; background-color: #f8f9fa; }
.section-pagination-controls span { font-size: 0.9em; color: #555; min-width: 50px; text-align: center; }

/* --- NEW Per-Section Loader Style --- */
.section-loader {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100px; /* Ensure it takes some space */
    color: #666;
    font-style: italic;
    padding: 20px;
}

/* --- NEW No Data Message Style --- */
.no-data-message {
  text-align: center;
  padding: 20px;
  color: #6c757d; /* A slightly muted grey */
  font-style: italic;
  border: 1px dashed #ccc;
  border-radius: 4px;
  margin-top: 10px;
}

/* --- Responsive Styles --- */
@media (max-width: 800px) {
  .column-right { padding-left: 15px; padding-right: 15px; padding-top: 70px; }
  .main-container { margin: 10px 0; }
  .dashboard-grid { grid-template-columns: 1fr; }
  td, th { font-size: 0.85em; padding: 6px 8px; }
  .dashboard-section h3 { font-size: 1em; }
  .badge { font-size: 0.75em; padding: 3px 8px; }
  .section-header { flex-direction: column; align-items: flex-start; gap: 5px; }
  .section-pagination-controls { margin-top: 5px; }
}
</style>

